import { Directive, Output, EventEmitter, HostListener } from '@angular/core';

@Directive({
    selector: '[appCheckCapslock]'
})
export class CheckCapslockDirective {
    @Output('capsLock') capsLock: EventEmitter<Object> = new EventEmitter();

    @HostListener('window:keydown', ['$event'])
        onKeyDown(event: KeyboardEvent): void {
         const capsOn = event.getModifierState && event.getModifierState('CapsLock');
         if(capsOn){
            this.capsLock.emit(true);
         } else {
            this.capsLock.emit(false);
         }
    }

    constructor() {
    }

}